import { render, staticRenderFns } from "./addOrEditKeyWorkType.vue?vue&type=template&id=7d1fe43b&scoped=true&"
import script from "./addOrEditKeyWorkType.vue?vue&type=script&lang=js&"
export * from "./addOrEditKeyWorkType.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditKeyWorkType.vue?vue&type=style&index=0&id=7d1fe43b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1fe43b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1fe43b')) {
      api.createRecord('7d1fe43b', component.options)
    } else {
      api.reload('7d1fe43b', component.options)
    }
    module.hot.accept("./addOrEditKeyWorkType.vue?vue&type=template&id=7d1fe43b&scoped=true&", function () {
      api.rerender('7d1fe43b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/KeyWordSettings/addOrEditKeyWorkType.vue"
export default component.exports